import { render, staticRenderFns } from "./transaction-records.vue?vue&type=template&id=8279ce84&scoped=true"
import script from "./transaction-records.vue?vue&type=script&lang=js"
export * from "./transaction-records.vue?vue&type=script&lang=js"
import style0 from "./transaction-records.vue?vue&type=style&index=0&id=8279ce84&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8279ce84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8279ce84')) {
      api.createRecord('8279ce84', component.options)
    } else {
      api.reload('8279ce84', component.options)
    }
    module.hot.accept("./transaction-records.vue?vue&type=template&id=8279ce84&scoped=true", function () {
      api.rerender('8279ce84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/service-provider-tools/transaction-records.vue"
export default component.exports